import {html} from 'lit';
import {customElement, property, query} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {classMap} from 'lit/directives/class-map.js';
import {watch} from '#lit/utils/dom.js';

export const COMPONENT_TAG = 'fly-tab-panel';

@customElement(COMPONENT_TAG)
export default class FlyTabPanel extends FlywheelComponent {
  @property()
  key = `${new Date().getTime()}-${Math.random()}`;

  @query('.fly-tab-panel') $node!: HTMLElement;

  @property() name = '';

  @property({type: Boolean, reflect: true}) active = false;
  @property({type: Boolean, reflect: true}) gridPanel = false;
  @property({type: Boolean, reflect: true}) noPadding = false;

  static get styles() {
    return [styles];
  }

  get classes() {
    return {
      'fly-tab-panel': true,
      'fly-tab-panel__no-padding': this.noPadding,
      'fly-tab-panel--active': this.active,
    };
  }

  @watch('active')
  dispatchChangeEvent() {
    window.dispatchEvent(new CustomEvent(`panel-change:${this.name}`));
  }

  render() {
    if (!this.active) {
      this.style.display = 'none';
    } else if (this.gridPanel) {
      this.style.display = 'grid';
    } else {
      this.style.display = 'block';
    }

    return html`
      <div
        class=${classMap(this.classes)}
        role="tabpanel"
        aria-labelledby=${this.name ? `${this.name}-tab` : ''}
      >
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_TAG]: FlyTabPanel;
  }
}
